<nav class="navbar navBg">
  <div class="container position-absolute pt-2">
    <ul class="m-auto iconsShow text-center">
      <a class="nav-link links-hover m-auto text-center pb-1 pt-4" routerLink="healthcare">
        <img src="assets/images/header-icon/Alfa logo.svg" alt="ALFA" class="w-50">
      </a>
      <li *ngIf="role">
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'services.Health Care' | translate}}"
          routerLink="healthcare">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/healthcare.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li *ngIf="role">
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'services.Health Care payment' | translate}}"
          routerLink="health-care-payment">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/payment.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li *ngIf="role">
        <a class="nav-link links-hover" routerLink="service" title="{{'services.services' | translate}}"
          routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/services.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li *ngIf="role">
        <a class="nav-link links-hover" routerLink="sub-service-List" title="{{'services.anotherservice' | translate}}"
          routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/services.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li *ngIf="role">
        <a class="nav-link links-hover" routerLink="Add-service-healthcare"
          title="{{'services.Add-Service' | translate}}" routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/Mask Group 57 (1).svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li *ngIf="role">
        <a class="nav-link links-hover" routerLink="pindind-sub-service"
          title="{{'services.Pendingservice' | translate}}" routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/pendingservices.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLink="hc-services" title="{{'services.get hc Service' | translate}}"
          routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/AddService.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>


      <li *ngIf="role">
        <a class="nav-link links-hover" routerLink="service-healthcare"
          title="{{'services.health service' | translate}}" routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/AddService.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>


      <li *ngIf="role">
        <a class="nav-link links-hover" routerLink="sub-service" title="{{'services.sub-service' | translate}}"
          routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/viewSub.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>

      <li>
        <a class="nav-link links-hover" routerLink="medical-specialties" title="{{'categories.categories' | translate}}"
          routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/categories/categories.png" class="svg" alt="ALFA">
          </span>
        </a>
      </li>

      <li>
        <a class="nav-link links-hover" routerLink="requests" title="{{'services.Pending orders' | translate}}"
          routerLinkActive="active">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/pendingorder.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'requests.rejected' | translate}}"
          routerLink="rejected">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/rejected.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'Register.Register' | translate}}"
          routerLink="get-register">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/registers.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'services.city' | translate}}" *ngIf="role"
          routerLink="city">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/cities.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'services.zone' | translate}}" *ngIf="role"
          routerLink="zones">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/zone.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>

      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'requests.offers' | translate}}"
          routerLink="offers">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/offers.svg" class="svg" alt="ALFA">
          </span>

        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'version.version' | translate}}" *ngIf="role"
          routerLink="app-version">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/version.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'services.admin' | translate}}" *ngIf="role"
          routerLink="admin">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/AddAdmin.svg" class="svg" alt="ALFA">
          </span>

        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'doctors.doctors' | translate}}"
          routerLink="doctors">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/doctor.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'taxs.app-taxs' | translate }}" *ngIf="role"
          routerLink="taxes">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/taxes.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" *ngIf="role"
          title='{{"services.commissions" | translate}}' routerLink="commision">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/commission.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'booking.faildBooking' | translate}}"
          routerLink="faild-Booking">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/uncompleted.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'booking.completed booking' | translate}}"
          routerLink="completed-Booking">
          <span class="span-circle rounded-circle">
            <img src="assets/images/completed-orders/Completed orders@2x.png" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'booking.new order' | translate}}"
          routerLink="new-order">
          <span class="span-circle rounded-circle">
            <img src="assets/images/orders/New Order@2x.png" class="svg" alt="ALFA" />
          </span>
        </a>
      </li>

      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'exports.exports' | translate}}"
          routerLink="exports">
          <span class="span-circle rounded-circle">
            <img src="assets/images/exports/export data@2x.png" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'booking.Booking' | translate}}"
          routerLink="refund-Booking">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/refunding.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'notification.notification' | translate}}"
          *ngIf="role" routerLink="notification">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/notification.png" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover" routerLinkActive="active" title="{{'user.user' | translate}}"
          routerLink="users">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/user.svg" class="svg" alt="ALFA">
          </span>
        </a>
      </li>
      <li>
        <a class="nav-link links-hover mb-2" routerLinkActive="active" title="{{'requests.contacts' | translate}}"
          routerLink="contacts">
          <span class="span-circle rounded-circle">
            <img src="assets/images/header-icon/contact.svg" class="svg" alt="ALFA">
          </span>

        </a>
      </li>

    </ul>
  </div>
</nav>